import { defineComponent, h, resolveComponent } from 'vue';
import { QCard, QCardSection, QBtn, QSeparator, QDialog, QTooltip } from 'quasar';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';
import FieldPicker from '../fieldPicker.jsx';
import SchemaForm from './SchemaForm.jsx';

export default defineComponent({
    name: 'form-array-dsgn',
    components: {
        QCard,
        QCardSection,
        QBtn,
        QSeparator,
        QDialog,
        QTooltip,
        FieldPicker,
        SchemaForm,
    },
    data: function () {
        return {
            pickervisible: false,
            picker: null,
        }
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
        addField(e) {
            this.picker = <FieldPicker schema={this.schema.items} confirm={this.confirmAddField} cancel={this.cancelAddField}></FieldPicker>;
            this.pickervisible = true;

            e.cancelBubble = true;
            e.stopPropagation();
        },
        async confirmAddField(fields) {
            this.pickervisible = false;

            if (!this.designmodel)
                return;

            if (this.designmodel.$typeSchema != '/schema/public/Platform.Schema.FormControls.v1/FormControl_ArrayField' &&
                this.designmodel.$typeSchema != '/schema/public/Platform.Schema.FormControls.v1/FormControl_TabArrayField') {
                // Convert from an AutoField (or whatever it was) to an ArrayField, then add the new fields to the Items array
                this.designmodel.$typeSchema = '/schema/public/Platform.Schema.FormControls.v1/FormControl_ArrayField';
                this.designmodel.type = 'array';
                this.designmodel.add = 'Add';
            }

            if (!Array.isArray(this.designmodel.items))
                this.designmodel.items = [];

            const form = this.designmodel.items;
            if (!form)
                return;

            if (form.length === 1 && (typeof form[0] === 'string') && form[0] === '*')
                form.splice(0, 1);

            for (let key in fields) {
                const v = fields[key];
                if (!v) continue;

                const fieldSchema = utils.schema.resolve_Of(v.type);
                const m = utils.schema.createDefaultModel(fieldSchema, this.root);
                m.key = key;
                m.$objectid = utils.generateUUID();
                form.push(m);
            }
        },
        cancelAddField() {
            this.pickervisible = false;
        },
        pickerInput(value) {
            this.pickervisible = value;
        },
        getPrimitiveTag(schema) {
            if (!schema)
                return null;

            if ('format' in schema && schema.format === 'LookupList')
                return 'string-lookup-list-dsgn';

            switch (schema.type) {
                case 'string':
                case 'text':
                case 'phonenumber':
                    if ('anyOf' in schema)
                        return 'form-anyof-dsgn';
                    if (('enum' in schema) || ('titleMap' in schema))
                        return 'form-select-dsgn';
                    return 'form-input-dsgn';
                case 'integer':
                case 'number':
                    return 'form-number-dsgn';
                case 'boolean':
                    return 'form-checkbox-dsgn';
                default:
                    return null;
            }
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        designmodel: null,
        schema: null,
        form: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
    },
    render() {
        const itemSchema = utils.schema.resolve_Of(this.schema.items);
        const arrayModel = Array.isArray(this.cmodel[this.schemakey]) ? this.cmodel[this.schemakey] : [];
        let designmodel = this.designmodel ?? {};

        // AI introduced the following bug. Beware, AI will initialize things sometimes just because... (2026-05-28 DP)
        //if (!designmodel.items || !Array.isArray(designmodel.items))
        //    designmodel.items = [];

        const itemForm = (itemSchema.type === 'object' && designmodel && Array.isArray(designmodel.items))
            ? designmodel.items
            : ['*'];

        const items = [];
        let itemValue = {};
        if (arrayModel.length > 0)
            itemValue = arrayModel[0];

        let preview;

        if (itemSchema.type === 'object') {
            preview = (
                <SchemaForm
                    name={this.name}
                    root={this.root}
                    schema={itemSchema}
                    form={itemForm}
                    cmodel={itemValue || {}}
                    child={1}
                    selectable={true}
                    selected={this.selected$}>
                </SchemaForm>
            );
        }
        else {
            const tagName = this.getPrimitiveTag(itemSchema);
            const Tag = tagName ? utils.getComponentByTag(tagName, 'default-unknown-dsgn') : null;
            const fieldSchema = { ...itemSchema, title: `[${this.name || 'unnamed'}]` };
            const rowModel = { item: itemValue };

            if (Tag) {
                preview = (
                    <Tag
                        name={this.name}
                        schemakey="item"
                        schema={fieldSchema}
                        root={this.root}
                        cmodel={rowModel}
                        child={0}
                        readonly={itemSchema.readonly || false}>
                    </Tag>
                );
            } else {
                preview = <div>{`[${this.name || 'unnamed'}] (unsupported item type: ${itemSchema.type || 'unknown'})`}</div>;
            }
        }

        items.push(
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {preview}
            </div>
        );
        

        let addFieldButton;
        if (this.selected$)
            addFieldButton = (
                <div class="property-grid designer-form" key="add-field-inline">
                    <QBtn
                        flat
                        size="sm"
                        icon="mdi-plus-circle"
                        color="blue-8"
                        style={{ zIndex: 32 }}
                        onClick={(e) => this.addField(e)}>
                        <QTooltip>Add field{this.schemakey ? ` (${this.schemakey})` : ''}</QTooltip>
                    </QBtn>
                </div>
            );

        return (
            <div
                class={{ 'designer-form': true }}
                style={{ marginLeft: (this.child * 15) + 'px', position: 'relative' }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QCard flat bordered class="q-mb-sm">
                    <QCardSection class="q-pb-sm">
                        <div class="text-subtitle2">{this.name}</div>
                    </QCardSection>
                    <QCardSection class="q-pt-none" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {items}
                        {addFieldButton}
                        <div class="property-grid q-mt-sm" key="add-another-preview">
                            <QBtn size="sm" icon="mdi-plus" color="primary">
                                Add Another
                                <QTooltip>Display preview only</QTooltip>
                            </QBtn>
                        </div>
                    </QCardSection>
                </QCard>
                <QDialog modelValue={this.pickervisible} onUpdate:modelValue={(value) => this.pickerInput(value)}>
                    <div style={{ maxWidth: '860px', maxHeight: '80vh', overflow: 'auto' }}>{this.picker}</div>
                </QDialog>
            </div>
        );
    }
});